"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/full-screen"),
    r = require("@react-pdf-viewer/get-file"),
    n = require("@react-pdf-viewer/open"),
    o = require("@react-pdf-viewer/page-navigation"),
    l = require("@react-pdf-viewer/print"),
    a = require("@react-pdf-viewer/properties"),
    i = require("@react-pdf-viewer/rotate"),
    c = require("@react-pdf-viewer/scroll-mode"),
    m = require("@react-pdf-viewer/search"),
    u = require("@react-pdf-viewer/selection-mode"),
    s = require("@react-pdf-viewer/theme"),
    d = require("@react-pdf-viewer/zoom"),
    p = require("@react-pdf-viewer/core");

function v(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (r) {
    if ("default" !== r) {
      var n = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, n.get ? n : {
        enumerable: !0,
        get: function get() {
          return e[r];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var _ = v(e),
    _E = function E() {
  return (_E = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var o in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    P = function P() {
  return _.createElement(p.Icon, {
    size: 16
  }, _.createElement("path", {
    d: "M12,0.5c1.381,0,2.5,1.119,2.5,2.5S13.381,5.5,12,5.5S9.5,4.381,9.5,3S10.619,0.5,12,0.5z\n            M12,9.5\n            c1.381,0,2.5,1.119,2.5,2.5s-1.119,2.5-2.5,2.5S9.5,13.381,9.5,12S10.619,9.5,12,9.5z\n            M12,18.5c1.381,0,2.5,1.119,2.5,2.5\n            s-1.119,2.5-2.5,2.5S9.5,22.381,9.5,21S10.619,18.5,12,18.5z"
  }));
},
    g = {
  left: 0,
  top: 8
},
    M = function M(e) {
  var t = e.toolbarSlot,
      r = _.useContext(p.LocalizationContext),
      n = t.DownloadMenuItem,
      o = t.EnterFullScreenMenuItem,
      l = t.GoToFirstPageMenuItem,
      a = t.GoToLastPageMenuItem,
      i = t.GoToNextPageMenuItem,
      m = t.GoToPreviousPageMenuItem,
      s = t.OpenMenuItem,
      d = t.PrintMenuItem,
      v = t.RotateBackwardMenuItem,
      E = t.RotateForwardMenuItem,
      M = t.ShowPropertiesMenuItem,
      h = t.SwitchScrollModeMenuItem,
      f = t.SwitchSelectionModeMenuItem,
      S = t.SwitchThemeMenuItem;

  return _.createElement(p.Popover, {
    ariaControlsSuffix: "toolbar-more-actions",
    ariaHasPopup: "menu",
    position: p.Position.BottomRight,
    target: function target(e, t) {
      var n = r && r.toolbar ? r.toolbar.moreActions : "More actions";
      return _.createElement(p.Tooltip, {
        ariaControlsSuffix: "toolbar-more-actions",
        position: p.Position.BottomRight,
        target: _.createElement(p.MinimalButton, {
          ariaLabel: n,
          onClick: e,
          isSelected: t
        }, _.createElement(P, null)),
        content: function content() {
          return n;
        },
        offset: g
      });
    },
    content: function content(e) {
      return _.createElement(p.Menu, null, _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(S, {
        onClick: e
      })), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(o, {
        onClick: e
      })), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(s, null)), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(d, {
        onClick: e
      })), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(n, {
        onClick: e
      })), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(p.MenuDivider, null)), _.createElement(l, {
        onClick: e
      }), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(m, {
        onClick: e
      })), _.createElement("div", {
        className: "rpv-core__display--block rpv-core__display--hidden-medium"
      }, _.createElement(i, {
        onClick: e
      })), _.createElement(a, {
        onClick: e
      }), _.createElement(p.MenuDivider, null), _.createElement(E, {
        onClick: e
      }), _.createElement(v, {
        onClick: e
      }), _.createElement(p.MenuDivider, null), _.createElement(f, {
        mode: u.SelectionMode.Text,
        onClick: e
      }), _.createElement(f, {
        mode: u.SelectionMode.Hand,
        onClick: e
      }), _.createElement(p.MenuDivider, null), _.createElement(h, {
        mode: c.ScrollMode.Vertical,
        onClick: e
      }), _.createElement(h, {
        mode: c.ScrollMode.Horizontal,
        onClick: e
      }), _.createElement(h, {
        mode: c.ScrollMode.Wrapped,
        onClick: e
      }), _.createElement(p.MenuDivider, null), _.createElement(M, {
        onClick: e
      }));
    },
    offset: g,
    closeOnClickOutside: !0,
    closeOnEscape: !0
  });
},
    h = function h(e) {
  var t = e.CurrentPageInput,
      r = e.Download,
      n = e.EnterFullScreen,
      o = e.GoToNextPage,
      l = e.GoToPreviousPage,
      a = e.NumberOfPages,
      i = e.Open,
      c = e.Print,
      m = e.ShowSearchPopover,
      u = e.SwitchTheme,
      s = e.Zoom,
      d = e.ZoomIn,
      p = e.ZoomOut;
  return _.createElement("div", {
    className: "rpv-toolbar",
    role: "toolbar",
    "aria-orientation": "horizontal"
  }, _.createElement("div", {
    className: "rpv-toolbar__left"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(m, null)), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-small"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(l, null))), _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(t, null), " ", _.createElement("span", {
    className: "rpv-toolbar__label"
  }, "/ ", _.createElement(a, null))), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-small"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(o, null)))), _.createElement("div", {
    className: "rpv-toolbar__center"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(p, null)), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-small"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(s, null))), _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(d, null))), _.createElement("div", {
    className: "rpv-toolbar__right"
  }, _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-medium"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(u, null))), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-medium"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(n, null))), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-medium"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(i, null))), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-medium"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(r, null))), _.createElement("div", {
    className: "rpv-core__display--hidden rpv-core__display--block-medium"
  }, _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(c, null))), _.createElement("div", {
    className: "rpv-toolbar__item"
  }, _.createElement(M, {
    toolbarSlot: e
  }))));
},
    f = function f(e) {
  var t = e.children,
      r = e.slot;
  return (t || h)(r);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.MoreActionsPopover = M, exports.MoreIcon = P, exports.toolbarPlugin = function (e) {
  var p = t.fullScreenPlugin(e ? e.fullScreenPlugin : {}),
      v = r.getFilePlugin(e ? e.getFilePlugin : {}),
      P = n.openPlugin(),
      g = o.pageNavigationPlugin(),
      M = l.printPlugin(e ? e.printPlugin : {}),
      h = a.propertiesPlugin(),
      S = i.rotatePlugin(),
      I = c.scrollModePlugin(e ? e.scrollModePlugin : {}),
      b = m.searchPlugin(e ? e.searchPlugin : {}),
      w = u.selectionModePlugin(e ? e.selectionModePlugin : {}),
      N = s.themePlugin(),
      y = d.zoomPlugin(e ? e.zoomPlugin : {}),
      k = [p, v, P, g, M, h, S, I, b, w, N, y];
  return {
    fullScreenPluginInstance: p,
    getFilePluginInstance: v,
    openPluginInstance: P,
    pageNavigationPluginInstance: g,
    printPluginInstance: M,
    propertiesPluginInstance: h,
    rotatePluginInstance: S,
    scrollModePluginInstance: I,
    searchPluginInstance: b,
    selectionModePluginInstance: w,
    themePluginInstance: N,
    zoomPluginInstance: y,
    install: function install(e) {
      k.forEach(function (t) {
        t.install && t.install(e);
      });
    },
    renderViewer: function renderViewer(e) {
      var t = e.slot;
      return k.forEach(function (r) {
        r.renderViewer && (t = r.renderViewer(_E(_E({}, e), {
          slot: t
        })));
      }), t;
    },
    uninstall: function uninstall(e) {
      k.forEach(function (t) {
        t.uninstall && t.uninstall(e);
      });
    },
    onDocumentLoad: function onDocumentLoad(e) {
      k.forEach(function (t) {
        t.onDocumentLoad && t.onDocumentLoad(e);
      });
    },
    onTextLayerRender: function onTextLayerRender(e) {
      k.forEach(function (t) {
        t.onTextLayerRender && t.onTextLayerRender(e);
      });
    },
    onViewerStateChange: function onViewerStateChange(e) {
      var t = e;
      return k.forEach(function (e) {
        e.onViewerStateChange && (t = e.onViewerStateChange(t));
      }), t;
    },
    Toolbar: function Toolbar(e) {
      var t = p.EnterFullScreen,
          r = p.EnterFullScreenMenuItem,
          n = v.Download,
          o = v.DownloadMenuItem,
          l = P.Open,
          a = P.OpenMenuItem,
          i = g.CurrentPageInput,
          c = g.CurrentPageLabel,
          m = g.GoToFirstPage,
          u = g.GoToFirstPageMenuItem,
          s = g.GoToLastPage,
          d = g.GoToLastPageMenuItem,
          k = g.GoToNextPage,
          T = g.GoToNextPageMenuItem,
          C = g.GoToPreviousPage,
          O = g.GoToPreviousPageMenuItem,
          G = M.Print,
          x = M.PrintMenuItem,
          F = h.ShowProperties,
          D = h.ShowPropertiesMenuItem,
          L = S.Rotate,
          q = S.RotateBackwardMenuItem,
          R = S.RotateForwardMenuItem,
          Z = I.SwitchScrollMode,
          z = I.SwitchScrollModeMenuItem,
          j = b.Search,
          V = b.ShowSearchPopover,
          B = w.SwitchSelectionMode,
          H = w.SwitchSelectionModeMenuItem,
          A = N.SwitchTheme,
          W = N.SwitchThemeMenuItem,
          J = y.CurrentScale,
          K = y.Zoom,
          Q = y.ZoomIn,
          U = y.ZoomInMenuItem,
          X = y.ZoomOut,
          Y = y.ZoomOutMenuItem;
      return _.createElement(f, _E({}, e, {
        slot: {
          CurrentPageInput: i,
          CurrentPageLabel: c,
          CurrentScale: J,
          Download: n,
          DownloadMenuItem: o,
          EnterFullScreen: t,
          EnterFullScreenMenuItem: r,
          GoToFirstPage: m,
          GoToFirstPageMenuItem: u,
          GoToLastPage: s,
          GoToLastPageMenuItem: d,
          GoToNextPage: k,
          GoToNextPageMenuItem: T,
          GoToPreviousPage: C,
          GoToPreviousPageMenuItem: O,
          NumberOfPages: function NumberOfPages() {
            return _.createElement(c, null, function (e) {
              return _.createElement(_.Fragment, null, e.numberOfPages);
            });
          },
          Open: l,
          OpenMenuItem: a,
          Print: G,
          PrintMenuItem: x,
          Rotate: L,
          RotateBackwardMenuItem: q,
          RotateForwardMenuItem: R,
          Search: j,
          ShowProperties: F,
          ShowPropertiesMenuItem: D,
          ShowSearchPopover: V,
          SwitchScrollMode: Z,
          SwitchScrollModeMenuItem: z,
          SwitchSelectionMode: B,
          SwitchSelectionModeMenuItem: H,
          SwitchTheme: A,
          SwitchThemeMenuItem: W,
          Zoom: K,
          ZoomIn: Q,
          ZoomInMenuItem: U,
          ZoomOut: X,
          ZoomOutMenuItem: Y
        }
      }));
    }
  };
};